import { render } from "./ResultDetails.vue?vue&type=template&id=19315683&scoped=true"
import script from "./ResultDetails.vue?vue&type=script&lang=js"
export * from "./ResultDetails.vue?vue&type=script&lang=js"

import "./ResultDetails.vue?vue&type=style&index=0&id=19315683&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19315683"]])

export default __exports__